<template>
	<div>
		<div class="bg-forgot">
			<img src="@/image/back-0.jpg" class="back-img-login" alt="" />
		</div>
		<div class="main-forgot">
			<div class="header_box">
				<div class="left">
					<div class="logo">
						<img src="../image/logo.png" alt="" @click="jumpChange" />
					</div>
					<div class="tab">
						<!-- <div class="item">重置密码</div> -->
					</div>
				</div>
				<div class="right">
					<!-- <div class="icon">
          <img src="../image/OA.png" alt="" />
        </div> -->
					<div @click="login" class="info_not">登录</div>
				</div>
			</div>

			<div class="login1">
				<div class="login_box">
					<div class="top">
						<div class="the-steps">
							<el-steps :active="iconActive" align-center>
								<el-step title="确认账号" icon="el-icon-edit">
									<template slot="icon">
										<div class="icon-step-thes">
											<img class="step-thes" src="../assets/icon/1@2x.png" alt="" />
										</div>
									</template>
								</el-step>
								<el-step title="重置密码" icon="el-icon-upload">
									<template slot="icon">
										<div class="icon-step-thes" v-show="active >= 1">
											<img class="step-thes" src="../assets/icon/22@2x.png" alt="" />
										</div>
										<div class="icon-step-thes" v-show="active < 1">
											<img class="step-thes" src="../assets/icon/2@2x.png" alt="" />
										</div>
									</template>
								</el-step>
								<el-step title="完成" icon="el-icon-picture">
									<template slot="icon">
										<div class="icon-step-thes" v-show="active >= 2">
											<img class="step-thes" src="../assets/icon/32@2x.png" alt="" />
										</div>
										<div class="icon-step-thes" v-show="active < 2">
											<img class="step-thes" src="../assets/icon/3@2x.png" alt="" />
										</div>
									</template>
								</el-step>
							</el-steps>

							<!-- <el-steps :active="active" finish-status="success">
              <el-step @click.native="nextone(0)" title="确认账号"> </el-step>
              <el-step @click.native="nextone(1)" title="重置密码"></el-step>
              <el-step @click.native="nextone(2)" title="完成"></el-step>
            </el-steps> -->
						</div>
					</div>

					<div v-if="active == 0" class="mid" style="padding-top: 30px">
						<div class="top">请填写您需要找回的账号</div>
						<div class="bottom">
							<div class="item">
								<input
									v-model="admin.phone"
									type="text"
									placeholder="请输入账号/手机号"
									maxlength="25"
								/>
							</div>
							<div class="item">
								<input
									type="text"
									placeholder="验证码"
									v-model="admin.post"
									name=""
									id=""
									maxlength="10"
								/>
								<!-- <img src="../image/xianshi.png" alt="" /> -->
								<!-- <span
                style="
                  font-weight: 400;
                  color: #e60000;
                  font-size: 14px;
                  width: 100px;
                "
                >获取验证码</span
              > -->
								<span
									style="
										font-weight: 400;
										color: #e60000;
										font-size: 14px;
										width: 100px;
										cursor: pointer;
									"
									@click="getPost"
									v-show="timer == null"
									>获取验证码</span
								><span
									style="font-weight: 400; color: #e60000; font-size: 14px; width: 100px"
									v-show="timer != null"
									>({{ count }})</span
								>
							</div>
							<!-- <div class="item1">
            <div class="left">
              <el-checkbox
                style="margin-right: 5px"
                v-model="checked"
              ></el-checkbox
              >下次自动登录
            </div>
            <div @click="Forgot_password" class="right"><span style="cursor: pointer;">忘记密码？</span></div>
          </div> -->
						</div>
					</div>
					<!--  <div v-if="active == 1" class="mid"> -->
					<div v-if="active == 1" class="mid" style="padding-top: 30px">
						<div class="top">请填写新密码</div>
						<div class="bottom">
							<div class="item">
								<input
									v-model="admin.passwrod"
									:type="showType ? 'password' : 'text'"
									placeholder="输入密码"
									@input="inputChange(0)"
									maxlength="20"
								/>
								<span class="input_tips" v-show="tipShow">{{ input_tips_txt }}</span>
								<img
									@click="showType1"
									v-if="showType"
									style="width: 12px; height: 12px"
									src="../image/xianshi.png"
									alt=""
								/>
								<img
									@click="showType1"
									v-else
									style="width: 12px; height: 12px"
									src="../image/yincang.png"
									alt=""
								/>
							</div>
							<div class="item">
								<input
									v-model="admin.passwrod1"
									:type="showType2 ? 'password' : 'text'"
									placeholder="确认密码"
									@input="inputChange(1)"
									maxlength="20"
								/>
								<span class="input_tips" v-show="tipShow1">{{ input_tips_txt }}</span>
								<img
									@click="showType0"
									v-if="showType2"
									style="width: 12px; height: 12px"
									src="../image/xianshi.png"
									alt=""
								/>
								<img
									@click="showType0"
									v-else
									style="width: 12px; height: 12px"
									src="../image/yincang.png"
									alt=""
								/>
							</div>
						</div>
					</div>

					<!--  <div v-if="active == 2" class="mid"> -->
					<div
						style="text-align: center; padding: 30px 0; margin-bottom: 15px; padding-top: 72px"
						v-if="active == 2"
						class="mid"
					>
						<img src="../image/cg.png" alt="" style="margin-bottom: 24px" />
						<div
							style="
								font-size: 18px;
								font-family: Alibaba PuHuiTi 2;
								font-weight: normal;
								color: #ffffff;
								line-height: 28px;
								opacity: 0.85;
							"
						>
							您的密码已重置成功，{{ downTimeNavigate }}秒后将自动跳转至登录页面！
						</div>
					</div>
					<!--  <div v-if="active == 2" class="mid"> -->
					<div class="bottom">
						<div class="top-return" v-if="active == 1 && is_returnTo">
							<span @click="returnByFirst">返回上一步</span>
						</div>
						<div v-if="active == 0" @click="next" class="top">下一步</div>
						<div v-else-if="active == 1" @click="subInfo" class="top">确认</div>
						<div v-else @click="login" class="top1" style="margin-top: 35px"> 立即登录 </div>
						<!-- <div class="bottom">
          <el-checkbox style="margin-right: 5px" v-model="checked"></el-checkbox
          >我已阅读并同意
          <span style="color: #46ace7;cursor: pointer;">《用户协议》</span>和<span
            style="color: #46ace7;cursor: pointer;"
            >《隐私政策》</span
          >
        </div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { $login, $send_code, $resetpwd, $userCheckCode } from '../api/index';

	export default {
		data() {
			return {
				is_returnTo: false,
				navigateToTimer: null,
				active: 0,
				downTimeNavigate: 3,
				timer: null,
				showType: 1,
				showType2: 1,
				admin: {
					phone: '',
					passwrod: '',
					passwrod1: '',
					post: '',
				},
				count: 60,

				// 新密码
				input_tips_txt: '请输入 8~16 位混合数字字符', // 输入框提示
				tipShow: false, // 输入框提示
				tipShow1: false, // 输入框提示
			};
		},
		computed: {
			iconActive: function () {
				return this.active + 1;
			},
		},
		beforeDestroy() {
			clearTimeout(this.navigateToTimer);
		},
		methods: {
			returnByFirst() {
				this.active = 0;
				this.admin.passwrod = '';
				this.admin.passwrod1 = '';
				this.is_returnTo = false;
			},
			subInfo() {
				let that = this;
				let data = {
					mobile: this.admin.phone,
					captcha: this.admin.post,
					newpassword: this.admin.passwrod,
					confirmpw: this.admin.passwrod1,
				};
				if (data.newpassword == '') {
					this.$message.error({
						message: '密码不能为空，请填写密码',
						showClose: true,
					});
					return;
				} else if (data.confirmpw == '') {
					this.$message.error({
						message: '确认密码不能为空，请确认密码',
						showClose: true,
					});
					return;
				} else if (data.newpassword != data.confirmpw) {
					this.$message.error({
						message: '两次密码输入不相同，请检查密码',
						showClose: true,
					});
					return;
				} else {
					// console.log(修改成功);
					$resetpwd(data)
						.then((response) => {
							that.active = 2;
							this.navigateToTimer = setInterval(() => {
								this.downTimeNavigate--;
								if (this.downTimeNavigate <= 0) {
									clearInterval(this.navigateToTimer);
									this.$router.push({
										path: '/login',
									});
								}
							}, 1000);
						})
						.catch((res) => {
							this.is_returnTo = true;
						});
				}
			},
			// nextone(e) {
			//   this.active = e;
			// },
			showType1() {
				this.showType = !this.showType;
			},
			showType0() {
				this.showType2 = !this.showType2;
			},
			getPost() {
				let that = this;
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				let phone = this.admin.phone;
				// if (phone == "" || phone.length <= 10 || !reg.test(phone)) {
				//   this.$message.error({message: "请检查手机号码，再试一次", showClose: true});
				//   return;
				// }
				if (!phone.trim()) {
					this.$message.error({
						message: 'OA账号/手机号 不能为空！',
						showClose: true,
					});
					return;
				}
				let data = {
					mobile: phone,
					event: 'resetpwd',
				};
				$send_code(data)
					.then((response) => {
						this.$message.success({
							message: `验证码已发送至手机${response.data.mobile}，请注意查收！`,
							showClose: true,
						});
						// this.$alert(
						//   `验证码已发送至手机${response.data.mobile}，请注意查收！`,
						//   "提示",
						//   {
						//     confirmButtonText: "确定",
						//     callback: () => {},
						//   }
						// );

						that.timer = setInterval(() => {
							if (this.count > 0) {
								that.count--;
							} else {
								clearInterval(that.timer);
								that.timer = null;
								that.count = 60;
							}
						}, 1000);
					})
					.catch((res) => {
						console.log(res);
					});
			},
			next() {
				let data = {
					post: this.admin.post,
					phone: this.admin.phone,
				};
				if (data.phone == '') {
					this.$message.error({
						message: '手机号码不能为空，请填写手机号码',
						showClose: true,
					});
					return;
				} else if (data.post == '') {
					this.$message.error({
						message: '验证码不能为空，请填写验证码',
						showClose: true,
					});
					return;
				} else {
					const loading = this.$loading({
						lock: true,
						text: '请稍等',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)',
					});
					$userCheckCode({
						mobile: data.phone,
						event: 'resetpwd',
						captcha: data.post,
					})
						.then((res) => {
							loading.close();
							this.active = 1;
						})
						.catch((err) => {
							loading.close();
							// this.$message({
							//   message: `验证码输入有无`,
							//   type: "error",
							//   callback: (action) => {},
							// });
						});
				}
			},

			login() {
				this.$router.push('/login');
			},

			// logo 跳转
			jumpChange() {
				this.$router.push('/');
			},

			// 新密码
			inputChange(num) {
				// 8-16位 大/小写英文数字混合，也可加特殊字符
				let filter = /^(?=.*[0-9\!@#\$%\^&\*])(?=.*[a-zA-Z]).{8,16}$/;
				let value = !num ? this.admin.passwrod : this.admin.passwrod1;
				if (filter.test(value)) {
					!num ? (this.tipShow = false) : (this.tipShow1 = false);
					return;
				}
				!num ? (this.tipShow = true) : (this.tipShow1 = true);
			},
		},
	};
</script>

<style scoped></style>

<style lang="scss" scoped>
	.header_box {
		display: flex;
		width: 70%;
		margin-top: 38px;
		margin-left: 15%;
		justify-content: space-between;
		.left {
			display: flex;
			align-items: center;

			.logo {
				margin-right: 35px;
				img {
					cursor: pointer;
					width: 190px;
					object-fit: contain;
				}
			}
			.tab {
				font-size: 26px;
				font-family: Alibaba PuHuiTi 2;
				font-weight: normal;
				color: #ffffff;
				opacity: 0.85;
				.item {
					margin-right: 72px;
					// border-bottom: 2px solid #e60000;
				}
			}
		}
		.right {
			display: flex;
			align-items: center;

			// .icon {
			//   margin-right: 32px;
			// }
			.info_not {
				font-size: 14px;
				cursor: pointer;
				font-weight: 500;
				color: #ffffff;
				width: 72px;
				height: 36px;
				background: #e60000;
				text-align: center;
				line-height: 36px;
			}
		}
	}
	.block {
		margin-top: 93px;
		display: flex;
		justify-content: center;
		.password_box {
			width: 810px;
			padding: 2% 11% 3% 11%;
			height: 486px;
			background: #282727;
			border-radius: 4px;
		}
	}

	.login1 {
		margin-top: 93px;
		display: flex;
		justify-content: center;
	}
	.login_box {
		width: 810px;

		padding: 2% 11% 3% 11%;
		padding-bottom: 84px;
		background: rgba(40, 39, 39, 1);
		opacity: 0.9;
		border-radius: 4px;
		.top {
			img {
				// margin-bottom: 65px;
			}
		}
		.mid {
			margin-bottom: 65px;

			.top {
				margin-top: 50px;
				display: flex;
				font-size: 16px;
				line-height: 28px;
				opacity: 0.85;
				color: #ffffff;
				.left {
					margin-right: 32px;
					.xian {
						width: 24px;
						height: 4px;
						background: #ffffff;
						opacity: 0.85;
						margin-top: 8px;
					}
				}
				.right {
				}
			}
			.bottom {
				.item {
					position: relative;
					margin-top: 27px;
					display: flex;
					align-items: center;
					border-bottom: 1px solid #585858;
					height: 45px;
					// margin-bottom: 30px;
					input {
						color: #ffffff;
						font-weight: 400;
						font-size: 14px;

						width: 100%;
						background-color: #282727;
						height: 100%;
						// padding: 0 10px;
					}
					.input_tips {
						position: absolute;
						left: 0;
						bottom: -20px;
						font-size: 14px;
						color: #e60000;
					}
				}
				.item1 {
					display: flex;
					font-size: 14px;
					justify-content: space-between;
					font-weight: 400;
					color: #ffffff;
					opacity: 0.5;
				}
			}
		}

		.bottom {
			position: relative;
			text-align: center;

			.top-return {
				position: absolute;
				top: -50px;
				width: 100%;
				height: 48px;
				// background: #ddd;
				// margin-top: 65px;
				font-size: 16px;
				color: #fff;
				text-align: center;
				line-height: 48px;
				span {
					cursor: pointer;
				}
			}

			.top {
				cursor: pointer;
				width: 100%;
				height: 48px;
				background: #e60000;
				// margin-top: 65px;
				font-size: 18px;

				// font-weight: bold;
				color: #ffffff;
				text-align: center;
				line-height: 48px;
			}
			.top1 {
				width: 40%;
				height: 48px;
				background: #e60000;
				font-size: 18px;

				// font-weight: bold;
				color: #ffffff;
				text-align: center;
				line-height: 48px;
				margin-left: 30%;
			}
			.bottom {
				font-size: 14px;
				margin-top: 19px;
				color: #999999;
			}
		}
	}
	.step-thes {
		width: 26px;
		height: 30px;
	}
	::v-deep .el-step__icon {
		background-color: #282727;
	}
	.icon-step-thes {
		width: 56px !important;
		height: 32px;
		display: flex;
		justify-content: center;
		// align-items: center;
		background-color: #282727;
	}
	::v-deep .el-step__icon.is-icon {
		width: 56px !important;
	}
	.the-steps {
		::v-deep .el-step__head {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		::v-deep .el-step__head.is-finish {
			color: #e60000 !important;
			// background: #e60000 !important;
		}

		::v-deep .el-step__title.is-finish {
			color: rgba(255, 255, 255, 0.85) !important;
		}

		::v-deep .el-step__line {
			border-color: #e60000;
			background-color: rgba(255, 255, 255, 0.1);
		}
		::v-deep .el-step__title.is-finish,
		::v-deep .el-step__title.is-wait,
		::v-deep .el-step__title.is-process {
			margin: 10px;
			color: rgba(255, 255, 255, 0.85) !important;
			font-weight: 500;
		}
	}
	.bg-forgot {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		// background: url('../image/back-0.jpg');
	}
	.main-forgot {
		position: relative;
		z-index: 2;
	}
	.back-img-login {
		position: relative;
		box-sizing: border-box;
		min-height: 900px;
		width: 1920px;
		object-fit: cover;
		filter: brightness(60%);
	}
</style>
